import $ from "jquery";
import CONFIG from "@bd-core/config";
import Storage from "@bd-utils/storage";
import {
    currentPageIsMainRoom,
    getCurrentPageId,
} from "@bd-stores/user-progress";
import bdjs from "@bd-core/bdjs";
import Timer from "@bd-utils/timer";

export default class CompletionPopup {
    constructor() {
        this.elms = {
            popup: ".js-room-completion",
            closeBtn: ".js-completionPopup-close",
            goToReflection: ".js-completion-btn",
            backToCompletion: ".js-go-to-completion",
            reflectionPopup: ".js-room-reflection"
        };

        return this;
    }

    init() {
        const self = this;
        const elms = this.elms;
        const $popup = $(elms.popup);
        this.timer = new Timer(() => {
        });

        $popup.find(elms.closeBtn).on("click", this.hide.bind(this));
        $popup.find(elms.goToReflection).on("click", function () {
            self.hide();
            $(elms.reflectionPopup).addClass("is-open");
        });

        return this;
    }

    _setHasSeen(roomId) {
        let states = Storage.get("states", {});
        if (!states?.completions) states.completions = [];
        states.completions.push(roomId);
        return Storage.set("states", states);
    }

    _getHasSeen(roomId) {
        let states = Storage.get("states", {});
        return states?.completions && states.completions.includes(roomId);
    }

    maybeResetState(roomId) {
        if (!this._getHasSeen(roomId)) return false;

        let states = Storage.get("states", {});
        if (!states?.completions) states.completions = [];

        const initialLength = states.completions.length;
        const completions = bdjs.removeItemArray(states.completions, roomId);

        //There is item removed, we need to update the Storage
        if (completions.length !== initialLength) {
            states.completions = completions;
            return Storage.set("states", states);
        }

        return false;
    }

    show(roomId) {
        // display completion popup only in current challenge room and main room
        const currentPageId = getCurrentPageId();
        const isCurrentPageMainroom = currentPageIsMainRoom();
        const hasSeen = this._getHasSeen(roomId);

        if(roomId !== currentPageId) return;

        if(hasSeen) return;

        if (hasSeen && isCurrentPageMainroom) return;

        const rooms = CONFIG?.game?.rooms || false;

        if (!Array.isArray(rooms) || !rooms.length) return;

        const room = rooms.find((r) => r?.id == roomId);
        if (!room) return;

        let $popup = $(this.elms.popup);
        let title = room?.room?.completion_popup?.completion_popup?.title || false;
        let subtitle = room?.room?.completion_popup?.completion_popup?.subtitle || false;
        let text = room?.room?.completion_popup?.completion_popup?.description || false;
        let btnLabel = room?.room?.completion_popup?.completion_popup?.button_label || false;

        if (isCurrentPageMainroom) {
            $(this.elms.goToMainRoom).addClass("is-mainroom");
        } else {
            $(this.elms.goToMainRoom).removeClass("is-mainroom");
        }

        if (!title && !text) return;

        if ($popup.hasClass("is-open")) this.hide();

        $popup.find(".js-completion-title").text(title);
        $popup.find(".js-completion-subtitle").text(subtitle);
        $popup.find(".js-completion-btn").text(btnLabel);
        if (text) $popup.find(".js-completion-description").html(text);
        
        $popup.addClass("is-open");
        $(".js-card").removeClass("is-open")
        $(".js-slider").removeClass("is-open")
        $(".js-card-ch-3").removeClass("is-open")


        // GameLogic.pauseTimer();

        if (!hasSeen) this._setHasSeen(roomId);
    }

    hide() {
        const $popup = $(this.elms.popup);
        // GameLogic.continueTimer();
        $popup.removeClass("is-open");
    }
}
